module.exports = __webpack_public_path__ + "static/carlsbad-13-dd70c5f683b3e19a378a0d5b7168ae04.png";